import 'react-hot-loader';
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import HttpsRedirect from 'react-https-redirect';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { ModalProvider } from 'react-modal-hook';
import { TransitionGroup } from 'react-transition-group';
import { ThemeProvider } from 'styled-components';
import { SnackbarProvider } from 'ui/containers/Providers/SnackbarProvider';
import AuthProvider from 'ui/containers/Providers/AuthProvider';
import { REACT_APP_SENTRY_DSN, REACT_APP_STRIPE_KEY, NODE_ENV } from '../src/config.js';
import * as Sentry from '@sentry/browser';
import * as serviceWorker from './serviceWorker';
import 'react-toastify/dist/ReactToastify.css';

import history from 'utils/history';
import configureStore from 'store/configureStore';

import App from 'ui/containers/App';
import theme from 'styles/theme';
import 'styles/index.scss';

if (REACT_APP_SENTRY_DSN !== 'none') Sentry.init({ dsn: REACT_APP_SENTRY_DSN });

const store = configureStore({}, history);

ReactDOM.render(
  <HttpsRedirect disabled={NODE_ENV !== 'production'}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <AuthProvider>
          <ThemeProvider theme={theme}>
            <SnackbarProvider>
              <ModalProvider container={TransitionGroup}>
                <App />
              </ModalProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </AuthProvider>
      </ConnectedRouter>
    </Provider>
  </HttpsRedirect>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
